import type { Feature, GeoJsonProperties, Point } from 'geojson';
import type { DealCard } from '../../utils/buildDealCards/dealCardTypes';

export const decoratePoints = (dealCards: DealCard[] | undefined): Feature<Point, GeoJsonProperties>[] => {
  if (!dealCards) {
    return [];
  }

  const points: Feature<Point, GeoJsonProperties>[] = [];
  const dealCardsFiltered = dealCards
    ? dealCards?.filter(
        (dealCard) => dealCard.product.accommodation.latitude !== 0 && dealCard.product.accommodation.longitude !== 0
      )
    : [];

  dealCardsFiltered.forEach((dealCard) => {
    const { longitude, latitude } = dealCard.product.accommodation;

    points.push({
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: [longitude, latitude],
      },
    });
  });

  return points;
};
